import { render } from "./BlueprintTileSmall.vue?vue&type=template&id=1aa80c7b"
import script from "./BlueprintTileSmall.vue?vue&type=script&lang=js"
export * from "./BlueprintTileSmall.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__